module.exports = __webpack_public_path__ + "img/performance-g.f8dcf498.png";